/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Birthday/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputFieldMasked from 'DesignSystem/TysiaInput/TysiaInputFieldMasked/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Birthday({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Main/Details/Birthday",
  isInvalid,
  onChange
  
}) {
  let isMedia = useIsMedia()
let profilePatientPersonBirthDateValueData = fromData.useDataFormat({ viewPath,
context: 'profile_patient',
path: 'person.birth_date',
format: fromFormat.dateISOIn,
})
let profilePatientPersonBirthDateIsValidData = fromData.useDataIsValid({ viewPath,
context: 'profile_patient',
path: 'person.birth_date',
validate: fromValidate.birthday,
required: true,
})
let profilePatientPersonBirthDateChangeData = fromData.useDataChange({ viewPath,
context: 'profile_patient',
path: 'person.birth_date',
formatOut: fromHelpers.formatOutDate,
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginTop={dtSpaceS}
 type="date"
 data="profile_patient.person.birth_date"
 format="/Data/format.js dateISOIn"
 formatOut="helpers.js formatOutDate"
 validate="/Data/validate.js birthday"
 invalid={!profilePatientPersonBirthDateIsValidData}
 value={profilePatientPersonBirthDateValueData}
 onChange={profilePatientPersonBirthDateChangeData}
 size={isMedia.mobile ? "small" : "medium"}
 required={true}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Date of birth"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputFieldMasked
{...childProps}
  viewPath={`${viewPath}/TysiaInputFieldMasked`}
 tabIndex={6}
 mask="date"
 yearTo={0}
 disableFuture={true}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}